import axios from "axios";
import { urlApi } from "@/global";

let cacheTiposUnidade = null;
let requestEmAndamento = null;

const cloneTipos = (tipos) => (Array.isArray(tipos) ? [...tipos] : []);

const getTiposCache = () => cloneTipos(cacheTiposUnidade);

export const listarTiposUnidade = () => getTiposCache();

export const listarTiposUnidadeOptions = () =>
  getTiposCache().map((tipo) => ({
    text: tipo,
    value: tipo,
  }));

export const carregarTiposUnidade = async ({ force = false } = {}) => {
  if (cacheTiposUnidade && !force) {
    return getTiposCache();
  }

  if (requestEmAndamento && !force) {
    return requestEmAndamento;
  }

  requestEmAndamento = axios
    .get(`${urlApi}/tipos-unidade`)
    .then((res) => {
      cacheTiposUnidade = cloneTipos(res.data);
      return getTiposCache();
    })
    .catch((err) => {
      cacheTiposUnidade = null;
      throw err;
    })
    .finally(() => {
      requestEmAndamento = null;
    });

  return requestEmAndamento;
};

export const obterRotuloTipoUnidade = (tipoUnidade, fallback = "-") => {
  if (tipoUnidade === null || tipoUnidade === undefined || tipoUnidade === "") {
    return fallback;
  }

  return typeof tipoUnidade === "string" ? tipoUnidade : String(tipoUnidade);
};
